import { render, staticRenderFns } from "./Lipsticks.vue?vue&type=template&id=6ee9e06f&scoped=true&"
import script from "./Lipsticks.vue?vue&type=script&lang=js&"
export * from "./Lipsticks.vue?vue&type=script&lang=js&"
import style0 from "./Lipsticks.vue?vue&type=style&index=0&id=6ee9e06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9e06f",
  null
  
)

export default component.exports